import {
  gridFilterableColumnDefinitionsSelector,
  GridFilterForm,
  GridFilterItem,
  useGridApiContext,
  useGridSelector,
  GridLinkOperator,
  GridFilterPanel
} from '@mui/x-data-grid-pro';
import { FC, SyntheticEvent, useState } from 'react';

export const TableDataGridFilter: FC = () => {
  const apiRef = useGridApiContext();
  const columns = useGridSelector(apiRef, gridFilterableColumnDefinitionsSelector);

  const initialFilterItem: GridFilterItem = {
    columnField: columns[0].field || '',
    operatorValue: columns[0].filterOperators && columns[0].filterOperators[0].value
  };
  const [filterItem, setFilterItem] = useState<GridFilterItem>(() => initialFilterItem);

  const handleColumnChange = (e: SyntheticEvent) => {
    const newFilter = {
      columnField: (e.target as HTMLSelectElement).value,
      operatorValue: undefined
    };
    setFilterItem(newFilter);
  };

  const handleOperatorChange = (e: SyntheticEvent) => {
    const newFilter = { ...filterItem, operatorValue: (e.target as HTMLSelectElement).value };
    setFilterItem(newFilter);
  };

  const handleValueChange = (e: SyntheticEvent) => {
    setFilterItem({ ...filterItem, value: (e.target as HTMLInputElement).value });
  };

  const deleteFilter = (item: GridFilterItem) => {
    apiRef.current.deleteFilterItem(item);
  };
  const applyFilterChanges = (item: GridFilterItem) => {
    apiRef.current.upsertFilterItem(item);
  };
  const applyMultiFilterOperatorChanges = (operator: GridLinkOperator) => {
    apiRef.current.setFilterLinkOperator(operator);
  };

  return (
    <GridFilterPanel
      sx={{
        '& option[value="isAnyOf"]': { display: 'none' },
        '& .MuiDataGrid-filterForm': {
          display: 'grid',
          gridTemplateColumns: 'min-content auto auto',
          gap: '1rem 0.5rem'
        },
        '& .MuiDataGrid-filterForm > .MuiFormControl-root:last-of-type': {
          gridColumn: '2 / span 2'
        }
      }}
    >
      <GridFilterForm
        item={filterItem}
        hasMultipleFilters={false}
        showMultiFilterOperators={false}
        deleteFilter={deleteFilter}
        applyFilterChanges={applyFilterChanges}
        applyMultiFilterOperatorChanges={applyMultiFilterOperatorChanges}
        columnInputProps={{ onChange: handleColumnChange }}
        operatorInputProps={{ onChange: handleOperatorChange }}
        valueInputProps={{ onChange: handleValueChange }}
        deleteIconProps={{
          onClick: () => setFilterItem(initialFilterItem)
        }}
      />
    </GridFilterPanel>
  );
};
